import React from "react";

const EtAdminAnalyticsOverview = () => {
  return (
    <div>
      <h2 className="text-xl font-bold text-orange-600 mb-3">
        Analytics Overview
      </h2>

      <p className="text-sm text-gray-600 mb-6">
        High-level insights about traffic, engagements, funnels, and conversions.
      </p>

      <div className="grid grid-cols-2 gap-4">
        <div className="p-4 bg-gray-100 rounded shadow">Total Sessions</div>
        <div className="p-4 bg-gray-100 rounded shadow">Total Sparks</div>
        <div className="p-4 bg-gray-100 rounded shadow">Top Pages</div>
        <div className="p-4 bg-gray-100 rounded shadow">Conversion Rate</div>
      </div>
    </div>
  );
};

export default EtAdminAnalyticsOverview;